module.exports = __webpack_public_path__ + "static/media/like_click.060134af.svg";